import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { isSet } from '../../../Utils/CommonFunctions';

class BreadCrumbsButton extends Component {
  
    defaultOnclickHandler(){
      
    }
    render () {
      let historyList = null;
      historyList = this.props.breadCrumbsList.backHistory.map((item, i) => {
          const to = (item.href) ? item.href: "#";
          return  <Wrp key={"wrp"+i}>
                  <li key={i} className="nav-item">
                    {item.clickHandler ? (
                      <a href={item.href || "#"} className="cursor-pointer" onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (item.clickHandler) {
                          item.clickHandler();
                        }
                      }}>{item.name}</a>
                    ) : (
                      <a href={to} className="cursor-pointer" onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (to !== "#") {
                          if (this.props.history) {
                            this.props.history.push(to);
                          } else {
                            // Fallback to window location if history is not available
                            window.location.href = to;
                          }
                        }
                      }}>{item.name}</a>
                    )}
                  </li>	
                  <li key={'arrow'+i}  className="separator">
                  <i className="fas fa-chevron-right fourth_light_color 1"></i>
                </li>
                </Wrp>
                  
                
      });
        return (
                <ul className="breadcrumbs">
                  {historyList}
                  <li className="nav-item d-inline-flex" title={""+isSet(this.props.breadCrumbsList.pageHoverTitle,'')}>
                    <div className="text-truncate" style={{maxWidth:'300px'}}>  {this.props.breadCrumbsList.pageTitle} </div>
                  </li>	
                </ul>
            
        )
    }
}

export default withRouter(BreadCrumbsButton);